type SurveyImageFolder = Readonly<Record<string, string | null | undefined>>;
type SurveyImageFolders = Readonly<Record<string, SurveyImageFolder | null | undefined>>;

export type SurveyImageSource = {
  readonly images?: SurveyImageFolders;
  readonly newImages?: SurveyImageFolders;
};

/**
 * Uses the newest available rendition, allowing older scans to supply missing demand images.
 * Surveys must be ordered newest first, as supplied by the survey reducer.
 */
export function getFieldSurveyImageUrl(
  fieldSurveys: readonly SurveyImageSource[],
  layer: string,
  resolveImageUrl: (images: SurveyImageFolders) => string | null | undefined
): string | null {
  for (const survey of fieldSurveys) {
    const images = { ...survey.images, ...survey.newImages };
    if (!images[layer]) continue;

    const imageUrl = resolveImageUrl(images);
    if (imageUrl) return imageUrl;
  }

  return null;
}
